import React, { Component } from 'react';
import LoginPage from './components/LoginPage';
import HeaderComponent from './components/HeaderComponent'
import { BrowserRouter } from 'react-router-dom'
class App extends Component {
  constructor(props){
    super(props);
    this.state={online:true};
  }
  componentDidMount(){
    this.timerID = setInterval(
      () => this.getInformation(),
      500
    );
  }
  getInformation(){
    this.setState({online:navigator.onLine});
  }
  render() {
    return (
      <div>
        <BrowserRouter>
          <div>
          <HeaderComponent />
          <LoginPage/>
          {this.state.online? '' :
            <div id="infoOnline">You are in Offline</div>
          }
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js